/*
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2023-11-20 16:22:03
 */
import Cookies from 'js-cookie'

const TokenKey = 'BDSOFT_TOKEN'
/*
* 获取getToken
* */
export function getToken () {
    return Cookies.get(TokenKey)
}
/*
* 设置setToken
* */
export function setToken (token) {
    return Cookies.set(TokenKey, token)
}
/*
* 移除removeToken
* */
export function removeToken () {
    return Cookies.remove(TokenKey)
}
